import store from '@/store';

const getParams = (serviceName, defaultParams) => {
  const currentService = store.state.responseOptions
    .filter(serviceOptions => serviceOptions.serviceName === serviceName)[0];

  if (!currentService) {
    return {
      ...defaultParams,
    };
  }

  return {
    ...defaultParams,
    ...currentService,
  };
};

export default getParams;
